import { CultureInfo } from '../culture-info.model';
import { CultureInfoQu } from './qu';

/**
 * @ignore
 */
export const CultureInfoQuPE: CultureInfo = {
  name: 'qu-PE',
  displayName: 'Runasimi (Perú)',
  iso3LanguageCode: 'que',
  iso2LanguageCode: 'qu',
  ietfLanguageTag: 'qu-PE',
  parent: CultureInfoQu
};
